<template>
  <div
    v-if="Object.keys(priceTableStore.priceRows).length > 0"
    class="relative"
  >
    <div class="mt-10 w-full">
      <PriceTableHeading />
      <PriceTableSelectedFiltersDisplay />

      <table class="mt-2 w-full table-auto">
        <thead>
          <tr>
            <th class="text-left">
              <span
                v-if="priceTableStore.isFavoriteOptionSelected"
                id="priceTableTop"
                class="scroll-m-20"
              >
                {{ $t('general.price_table.filters.favorite_size') }}
              </span>
              <span v-else id="priceTableTop" class="scroll-m-20">
                {{ $t('general.price_table.size') }}
              </span>
            </th>
            <th
              v-if="priceTableStore.hasAnyRecommendedPrice"
              class="pl-4 text-right"
            >
              {{ $t('general.price_table.from') }}
            </th>
            <th class="pl-4 text-right">
              {{ $t('general.price_table.for') }}
            </th>
          </tr>
        </thead>

        <tbody>
          <template v-if="true">
            <TransitionGroup name="fade-row">
              <template
                v-for="(row, index) in showTableRows"
                :key="`price_table_row_${index}`"
              >
                <tr v-if="row.price > 0" class="w-full">
                  <td class="my-2 flex items-center gap-2 text-left first:py-0">
                    <span>
                      {{ row.label }}
                    </span>

                    <span>
                      <BadgeLabel
                        v-if="row.sku === priceTableStore.mostChosenSku"
                        :label="$t('pages.configurator.sizes.most_chosen')"
                        class="shrink-0 self-auto bg-order-buttons/20 text-order-buttons"
                      />
                    </span>
                  </td>
                  <td
                    v-if="priceTableStore.hasAnyRecommendedPrice"
                    class="py-2 pl-4 text-right"
                  >
                    <span
                      v-if="
                        row.recommendedPrice &&
                        row.localizedRecommendedPrice &&
                        row.recommendedPrice > row.price
                      "
                      class="text-gray-lighter line-through"
                      v-html="row.localizedRecommendedPrice"
                    />
                    <span v-else class="text-gray-lighter">-</span>
                  </td>
                  <td
                    class="py-2 pl-4 text-right font-bold text-order-buttons md:text-tertiary"
                  >
                    <span v-html="row.localizedPrice" />
                  </td>
                </tr>
              </template>
            </TransitionGroup>
          </template>
        </tbody>
      </table>

      <PriceTableShowMoreButton />
    </div>

    <PriceTableFilterPopUp />
  </div>
</template>

<script setup lang="ts">
import { computed, type ComputedRef, onMounted } from 'vue';
import BadgeLabel from '@/components/BadgeLabel.vue';
import { usePriceTableStore } from '@/stores/PriceTable/PriceTableStore.ts';
import PriceTableFilterPopUp from '@/pages/ProductPage/partials/PriceTable/PriceTableFilterPopUp.vue';
import PriceTableShowMoreButton from '@/pages/ProductPage/partials/PriceTable/PriceTableShowMoreButton.vue';
import PriceTableSelectedFiltersDisplay from '@/pages/ProductPage/partials/PriceTable/PriceTableSelectedFiltersDisplay.vue';
import PriceTableHeading from '@/pages/ProductPage/partials/PriceTable/PriceTableHeading.vue';
import type { PriceTableMobileAllPricesObject } from '@/types/joostconnector';

const priceTableStore = usePriceTableStore();

const showTableRows: ComputedRef<PriceTableMobileAllPricesObject[]> = computed(
  () => {
    const rows = priceTableStore.showMore
      ? priceTableStore.priceRows
      : priceTableStore.limitedPriceRows;
    return Array.isArray(rows) ? rows : Object.values(rows);
  }
);

onMounted(priceTableStore.setDefaultCutoutFilterValue);
</script>

<style scoped>
.fade-row-enter-active,
.fade-row-leave-active {
  transition: opacity 0.3s;
}
.fade-row-enter-from,
.fade-row-leave-to {
  opacity: 0;
}
.fade-row-enter-to,
.fade-row-leave-from {
  opacity: 1;
}
</style>
